import { useCallback, useEffect, useRef, useState } from 'react';

export default function useDebounceMatrix(onDebounce, delay = 1000) {
  const debounces = useRef([]);
  const matrixValues = useRef([]);
  const [debouncesLength, setDebouncesLength] = useState(0);

  useEffect(() => {
    if (debouncesLength === 0 && matrixValues.current.length > 0) {
      onDebounce(matrixValues.current);
      matrixValues.current = [];
    }
  }, [debouncesLength, onDebounce]);

  useEffect(
    () => () => {
      // execute onDebouce when leaving page and then clear
      if (matrixValues.current.length > 0) {
        onDebounce(matrixValues.current);
        matrixValues.current = [];
      }
      matrixValues.current = [];
      debounces.current.forEach((dbc) => {
        clearTimeout(dbc?.debounceFunction);
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const update = useCallback(
    (newVal, id) => {
      if (matrixValues.current.some((val) => val.id === id)) {
        // if value exist in array update it
        matrixValues.current = matrixValues.current.map((mtrxVal) => ({
          ...mtrxVal,
          val: mtrxVal.id === id ? newVal : mtrxVal.val,
        }));
      } else {
        // if value doesnt exist add new element
        matrixValues.current.push({ id, val: newVal });
      }
      if (debounces.current.some((dbcs) => dbcs.id === id)) {
        // debounce is in list so we stop timeout and start new one
        debounces.current = debounces.current.map((dbc) => {
          if (dbc.id === id) {
            clearTimeout(dbc.debounceFunction);
            return {
              ...dbc,
              debounceFunction: setTimeout(() => {
                debounces.current = debounces.current.filter((timeoutDbc) => timeoutDbc.id !== id);
                setDebouncesLength((dbcsLength) => dbcsLength - 1);
              }, delay),
            };
          }
          return dbc;
        });
      } else {
        debounces.current.push({
          id,
          debounceFunction: setTimeout(() => {
            debounces.current = debounces.current.filter((timeoutDbc) => timeoutDbc.id !== id);
            setDebouncesLength((dbcsLength) => dbcsLength - 1);
          }, delay),
        });
        setDebouncesLength((dbcsLength) => dbcsLength + 1);
      }
    },
    [delay]
  );

  return [update];
}
